import Button from './ui/Button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/Card';
import Shell from './ui/Shell';

interface ErrorScreenProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  hint?: string;
}

export default function ErrorScreen({
  title = 'Something went wrong',
  message,
  onRetry,
  hint,
}: ErrorScreenProps) {
  return (
    <Shell centered maxWidth="narrow">
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <p className="text-base text-foreground/80">{message}</p>
          {hint && <p className="text-sm text-muted-foreground">{hint}</p>}
        </CardHeader>
        <CardContent className="space-y-3">
          {onRetry && (
            <div className="flex justify-end">
              <Button onClick={onRetry}>Try again</Button>
            </div>
          )}
          <p className="text-xs text-muted-foreground">
            If this keeps happening, contact your recruiter with the error message
            above.
          </p>
        </CardContent>
        <CardFooter />
      </Card>
    </Shell>
  );
}
